import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useTheme } from '../hooks/useTheme'
import SimpleHeader from '../components/common/SimpleHeader'
import Footer from '../components/common/Footer'

const PaymentCancelledPage: React.FC = () => {
  const navigate = useNavigate()
  const { colors } = useTheme()

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <SimpleHeader
        title="Pago Cancelado"
        subtitle="Tu pago ha sido cancelado"
      />

      <div className="flex-1 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-md w-full">
          <div
            className="bg-white shadow-xl rounded-2xl p-8 border-2"
            style={{ borderColor: `${colors.primaryLight}40` }}
          >
            {/* Icono de cancelación */}
            <div
              className="mx-auto flex items-center justify-center h-16 w-16 rounded-full mb-6"
              style={{ backgroundColor: `${colors.primaryLight}40` }}
            >
              <svg
                className="h-10 w-10"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                style={{ color: colors.primary }}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </div>

            {/* Título */}
            <h2 className="text-center text-3xl font-bold text-gray-900 mb-2">
              Pago Cancelado
            </h2>
            <p className="text-center text-gray-600 mb-6">
              Has cancelado tu pago. No se realizó ningún cargo en tu cuenta.
            </p>

            {/* Información */}
            <div
              className="rounded-lg p-4 mb-6 border"
              style={{
                backgroundColor: `${colors.primaryLight}20`,
                borderColor: `${colors.primary}40`
              }}
            >
              <p className="text-sm" style={{ color: colors.primary }}>
                <strong>¿Qué pasó?</strong>
                <br />
                Decidiste no continuar con el pago. Tu reserva fue eliminada y el espacio liberado.
              </p>
            </div>

            {/* Botones de acción */}
            <div className="space-y-3">
              <button
                onClick={() => navigate('/reservar')}
                className="w-full btn-lg font-semibold text-white rounded-lg py-3 transition-all"
                style={{
                  backgroundColor: colors.primary,
                  opacity: 1
                }}
                onMouseEnter={(e) => (e.currentTarget.style.opacity = '0.9')}
                onMouseLeave={(e) => (e.currentTarget.style.opacity = '1')}
              >
                🔄 Volver a Reservar
              </button>

              <button
                onClick={() => navigate('/')}
                className="w-full btn-lg font-semibold rounded-lg py-3 border-2 transition-all"
                style={{
                  color: colors.primary,
                  borderColor: colors.primary,
                  backgroundColor: 'transparent'
                }}
                onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = `${colors.primaryLight}20`)}
                onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = 'transparent')}
              >
                🏠 Volver al Inicio
              </button>
            </div>

            {/* Ayuda */}
            <div className="mt-6 pt-6 border-t border-gray-200">
              <p className="text-xs text-gray-500 text-center">
                Si tienes problemas, por favor contáctanos
              </p>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  )
}

export default PaymentCancelledPage
